//@ts-nocheck
import config from "@/configs";
import { BookTypeEnum } from "@/interface/IBook";
import { ISearchResultQuery } from "../pages/Search/type";
import qs from "qs";
import _isEmpty from "lodash/isEmpty";

export const bookcover = (
  id: string,
  size: number | null,
  updateTime: number | string | undefined
) => {
  const height = size ? size * 2.5 : null;
  return `${config.cover}/1001/bookcover/${id}?imageMogr2${
    size != null ? `/thumbnail/${size}x${height}` : ""
  }/quality/50/strip&imageId=${updateTime ?? ""}&_t=0`;
};

export const addWebPPrefix = (url: string, isSupportWebp?: boolean) => {
  // url 不合格或者已经有 webp 后缀
  if (
    !url ||
    !url.includes(".chereads") ||
    url.includes("imageMogr2/format/webp")
  ) {
    return url;
  }

  // 优先走参数中的 isSupportWebp
  let supportWebP = isSupportWebp;
  if (typeof isSupportWebp === "undefined") {
    supportWebP =
      typeof window === "undefined" ? false : !!window.IS_SUPPORT_WEBP;
  }
  if (!supportWebP) {
    return url;
  }

  // 支持 WEBP
  if (url.indexOf("?") === -1) {
    return `${url}?imageMogr2/format/webp`;
  }

  const urlArray = url.split("?");
  return `${urlArray[0]}?imageMogr2/format/webp&${urlArray[1]}`;
};

export const withUpdateTime = (url, updateTime) =>
  addWebPPrefix(`${url}${updateTime ? `?updateTime=${updateTime}` : ""}`);

/**
 * 将字符 format 成全小写，中划线连接的 URIComponent
 * @param string
 * @returns {string}
 */
export const toLowerCaseAndHyphenURIComponent = (string = "") =>
  `${encodeURIComponent(
    string
      .replace(/[;/?:@&=+$,# _\n]+/g, "-")
      .replace(/^(-*)/, "")
      .replace(/(-*)$/, "")
      .toLocaleLowerCase()
  )}`;
/**
 * 修改书封尺寸为自适应
 * @param size
 * @returns {number}
 */
const getBookCoverSizeBySize = (size) => {
  if (size <= 150) {
    return 150;
  }
  if (size <= 180) {
    return 180;
  }
  if (size <= 300) {
    return 300;
  }
  if (size <= 450) {
    return 450;
  }
  if (size <= 600) {
    return 600;
  }
  return 150;
};

export enum TagPageSourceEnum {
  homepage,
  search,
}

/**
 * ⚠️ 旧版的，已废弃
 * @param tagName
 * @param tagId
 * @param source TagPageSourceEnum，默认不传，为书城
 */
export const tagUrl = (tagName = "", tagId = 0, source?: TagPageSourceEnum) => {
  return `/tag/${tagId}/${encodeURIComponent(
    tagName.toLowerCase().replace(/ /g, "-")
  )}${source !== undefined ? `?source=${source}` : ""}`;
};
/**
 *
 * @param tagName
 * @param tagId
 * @param source TagPageSourceEnum，默认不传，为书城
 */
export const pureTagUrl = (
  tagName = "",
  tagId = 0,
  source?: TagPageSourceEnum
) => {
  return `/tag/${tagId}-${encodeURIComponent(
    tagName.toLowerCase().replace(/ /g, "-")
  )}${source !== undefined ? `?source=${source}` : ""}`;
};
export const parseTagUrlParams = (
  tagId?: string,
  tagName?: string
): Pick<ITagListQueryTypes, "tagId", "tagName"> => {
  return {
    tagId: +tagId || 0,
    tagName: tagName.replace(/-stories$/, "").replace("-", " "),
  };
};

// 从41000075-reincarnation 格式中解析出 tagId，tagName
export const parseTagUrlParamsFromUrl = (path: string) => {
  const parts = path.split("-");
  const [tagId = "", tagName = ""] = parts;
  return parseTagUrlParams(tagId, tagName);
};

/**
 * 判断是否是合法域名的url, 以免被信任攻击
 * @method isValidUrl
 * @param url
 */
export const isValidUrl = (url) => {
  // 如果是是 / 开始，则是相对当前域的url, 则都是合法的url
  if (/^\/[^/]*/.test(url)) {
    return true;
  }
  // 不是的话，则判断域名是不是在chereads.com下面
  // https://*.chereads.com
  // https://*.chereads.com/
  // https://*.chereads.com?
  // https://*.chereads.com#
  const result = url.match(/^https?:\/\/[^.]*?\.chereads\.com($|\/.*|\?|#)/);
  return !!result;
};

export enum SearchPageSourceEnum {
  hot = 0,
}

export const decodeSearchUrlParam = (
  keyword?: string
): Pick<ISearchResultQuery, "keyWord", "itemType"> => {
  const kw: string = keyword || "";
  if (/-manga$/.test(kw)) {
    return {
      keyWord: kw.replace(/-manga$/, "").replace(/-/g, " "),
      itemType: BookTypeEnum.Comic,
    };
  }
  return {
    keyWord: kw.replace(/-novels$/, "").replace(/-/g, " "),
    itemType: BookTypeEnum.Novel,
  };
};
export const searchUrl = (keyword, query?: Partial<ISearchResultQuery>) => {
  const { keyWord, itemType = BookTypeEnum.Novel, ...otherQuery } = query || {}; // query里可能有keyWord，先过滤出来
  const formattedKW = encodeURIComponent(
    keyword.toLowerCase().replace(/ /g, "-")
  );
  const formattedItemType =
    itemType === BookTypeEnum.Comic ? "manga" : "novels"; // 默认 novels
  if (!_isEmpty(otherQuery)) {
    return `/search/${formattedKW}-${formattedItemType}?${qs.stringify(
      otherQuery
    )}`;
  }
  return `/search/${formattedKW}-${formattedItemType}`;
};
/**
 * 从 ${otherString}_${id} 中获取 id
 * @param str
 * @returns {*}
 */
export const getIdFromURIComponent = (str) => {
  if (!str) {
    return "";
  }
  const regResult = str.match(/_?(\d+)$/);
  if (regResult) {
    return regResult[1];
  }
  return "";
};

interface ChapterUrlParamType {
  novelType: BookTypeEnum;
  bookId: number | string;
  bookName: string;
  chapterIndex?: number | string;
  chapterId?: number | string;
  isPureId?: boolean;
}

/**
 * 组合构建SEO友好的chapter链接
 * @param param
 * @returns
 */
export const composeChapterUrl = (param: ChapterUrlParamType) => {
  const {
    novelType,
    bookId,
    bookName,
    chapterIndex,
    chapterId,
    isPureId = false,
  } = param;
  const prefix = novelType === BookTypeEnum.Novel ? "novel" : "manga";
  const validBookName = bookName
    .toLowerCase()
    .replace(/([^a-zA-Z0-9]+)/g, "-")
    .replace(/^-/, "")
    .replace(/-$/, "");

  let bookPart = validBookName ? `${bookId}-${validBookName}` : bookId;
  let chapterPart =
    chapterId && chapterIndex ? `chapter${chapterIndex}-${chapterId}` : "";
  if (isPureId) {
    // 纯id格式的小说页
    bookPart = bookId;
    chapterPart = chapterId ? `${chapterId}` : "";
  }

  return "/" + [prefix, bookPart, chapterPart].filter(Boolean).join("/");
};

/**
 * 从url中解析出bookId、chapterId
 * @param url
 * @returns
 */
export const decodeChapterUrl = (
  url: string
): Omit<ChapterUrlParamType, "bookName"> => {
  const parts = url.slice(1).split("/");
  const [prefix = "", bookPart = "", chapterPart = ""] = parts;
  const bookId = bookPart.replace(/([0-9]+)(?:-[a-zA-Z0-9\-]+)?/, "$1");

  let chapterId;
  let chapterIndex;
  if (chapterPart) {
    const match = chapterPart.match(/(?:chapter)?(?:([0-9]+)-)?([0-9]+)/);
    if (match && match.length === 3) {
      chapterIndex = match[1];
      chapterId = match[2];
    }
  }

  return {
    prefix,
    bookId,
    chapterId,
    chapterIndex,
  };
};

/**
 * 从url中解析出bookId
 * @param url
 * @returns
 */
export const decodeChapterListUrl = (url: string): string =>
  decodeChapterUrl(url).bookId;

export const chapterListUrl = (param: {
  novelType: BookTypeEnum;
  bookId: string;
  bookName?: string;
}) => {
  const { novelType, bookId, bookName = "" } = param;
  const prefix =
    novelType === BookTypeEnum.Novel ? "chapterlist" : "manga-chapterlist";
  const validBookName = bookName
    .toLowerCase()
    .replace(/([^a-zA-Z0-9]+)/g, "-")
    .replace(/^-/, "")
    .replace(/-$/, "");

  const bookPart = validBookName ? `${bookId}-${validBookName}` : bookId;
  return `/${prefix}/${bookPart}`;
};

export const isPureIdChapterListUrl = (pathname: string) =>
  /\/(chapterlist|manga-chapterlist)\/\d+$/.test(pathname);

// 拼接用户头像
export const avatarUrl = (userId: number, appId: number, uut: number) => {
  return `https://${
    config.envType === "pre" || config.envType === "pro" ? "" : "oa-"
  }user-pic.webnovel.com/userheadimg/${userId}-${appId}/100.jpg?uut=${uut}&imageMogr2/quality/80`;
};

export const getHost = () => {
  return (
    config.protocol +
    `${config.envType === "pro" ? "" : config.envType}www.chereads.com`
  );
};

export const isOnlyId = (txt) => /^\d+$/.test(txt);

/**
 * 话题列表页url
 * @param {*} letter
 * @param {*} pageIndex
 * @returns
 */
export const getSubjectListUrl = (letter = "", pageIndex = 1) => {
  return (
    `/so` +
    (letter ? `/${letter}` + (pageIndex > 1 ? `_${pageIndex}` : "") : "")
  );
};

/**
 * 话题详情页url
 * @param {*} id
 * @returns
 */
export const getSubjectDetailUrl = (id = "") => {
  return `/so` + (id ? `/${id}` : "");
};
